
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { getOrgCodeListByPage } from "@/api/service";
import { LogHelper } from "@/common/LogHelper";

@Component({
  name: "PdaUsercodename",
  components: {
    // SingleStatistical,
    // Breadcrumb,
    // Hamburger,
  },
  props: {
    pdsuserdialogshowFlag: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    pdsuserdialogshowFlag(newone, oldone) {
      if (newone) {
        this.pdausercodenameDialogFormVisible = true;
        try {
          this.findpdausercodename();
        } catch (error) {
          LogHelper.Error("pdsuserdialogshowFlag失败");
          LogHelper.Error(error);
        }
      }
    },
  },
})
export default class extends Vue {
  public selectElementContents(el) {
    //失去焦点，获取焦点
    // el.blur();
    el.focus();
  }

  public openDialog(formName) {
    this.$nextTick(function () {
      this.selectElementContents(
        document.getElementById("input_pdausercodename")
      );
    });
  }

  private registedObj1 = null;
  private curPagePdausercodename = 1;
  private currentrowpdausercodename = null;
  private pdausercodenamepagination = 100;
  private pdausercodenameDialogFormVisible = false;
  private pdausercodenameform = {
    pdausercodename: "",
  };
  private tableDatapdausercodename = [];

  private pdausercodenameDialogFormOK(ConfirmFlag) {
    console.log("|FUNC|pdausercodenameDialogFormOK:" + ConfirmFlag);

    if (ConfirmFlag) {
      //接口查询
      if (this.currentrowpdausercodename != null) {
        this.$emit("pdausercodename", this.currentrowpdausercodename);
      } else {
        LogHelper.Error("|FUNC|pdausercodenameDialogFormOK:" + "未选择员工行");
        return;
      }
    } else {
      this.$emit("pdausercodename", null); //返回空对象
    }
    this.pdausercodenameDialogFormVisible = false;
    this.pdausercodenameform.pdausercodename = "";
  }

  private tablehandleCurrentChangepdausercodename(val) {
    console.log("|FUNC|tablehandleCurrentChangepdausercodename");
    console.log(val);
    this.currentrowpdausercodename = val;
  }

  private doubleclickselectpdausercodename(row) {
    console.log("|FUNC|doubleclickselectpdausercodename");
    console.log(row);
    this.pdausercodenameDialogFormVisible = false;
    this.$emit("pdausercodename", row);
    this.pdausercodenameform.pdausercodename = "";
  }

  private searchpdausercodename() {
    console.log("|FUNC|searchpdausercodename");
    if (typeof (obj_HttpRequest_Core) != "undefined") {
      let responseStr = this.GetPdaUserListByPage(
        10,
        1,
        this.pdausercodenameform.pdausercodename
      );
      this.initpdauser(responseStr);
    } else {
      obj_ScanForAcceptPacket.getPdaUserListByPage(
        10,
        1,
        this.pdausercodenameform.pdausercodename,
        this.initpdauser
      );
    }
    this.curPagePdausercodename = 1;
  }

  private handleCurrentChangepdausercodename(val) {
    console.log("|FUNC|handleCurrentChangepdausercodename");
    console.log(val);
    if (typeof (obj_HttpRequest_Core) != "undefined") {
      let responseStr = this.GetPdaUserListByPage(
        10,
        val,
        this.pdausercodenameform.pdausercodename
      );
      this.initpdauser(responseStr);
    } else {
      obj_ScanForAcceptPacket.getPdaUserListByPage(
        10,
        val,
        this.pdausercodenameform.pdausercodename,
        this.initpdauser
      );
    }
  }

  public findpdausercodename() {
    console.log("|FUNC|findpdausercodename");
    this.pdausercodenameDialogFormVisible = true;
    if (typeof (obj_HttpRequest_Core) != "undefined") {
      let responseStr = this.GetPdaUserListByPage(
        10,
        1,
        this.pdausercodenameform.pdausercodename
      );
      this.initpdauser(responseStr);
    } else {
      obj_ScanForAcceptPacket.getPdaUserListByPage(
        10,
        1,
        this.pdausercodenameform.pdausercodename,
        this.initpdauser
      );
    }
  }
  private GetPdaUserListByPage(pageSize, current, filter) {
    let body = {
      queryValue: filter, //过滤字符串
      queryType: "20",
      viewType: "1",
      extend1: current.toString(), //当前页
      extend2: pageSize.toString(), //页大小
      extend3: "", //过滤字段
    };
    let job = {
      devMac: "00-00-00-00-00-00",
      devType: "0",
      body: body,
    };

    var result = getOrgCodeListByPage(JSON.stringify(job));
    if (result != null && result.length > 0) {
      try {
        return result;
      } catch (ex) {
        LogHelper.WriteLog("获取收派员失败：" + ex);
      }
    } else {
      return {};
    }
  }
  //初始化用户数据
  private initpdauser(datas): void {
    console.log("|FUNC|initpdauser");

    var jsonobj = JSON.parse(datas);

    if (jsonobj.respcode == "000") {
      var allpersons = jsonobj.data.busiData.records;
      console.log(allpersons);
      this.tableDatapdausercodename = allpersons;
      this.pdausercodenamepagination = jsonobj.data.busiData.total;
    } else {
      console.log(jsonobj);
    }
  }
}
